module.exports = __webpack_public_path__ + "static/img/vrroad_img2.45d29e3e.png";